import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';

// Remove if react-quill is not used
// import "react-quill/dist/quill.snow.css";
// import 'react-quill-new/dist/quill.snow.css'; // Import Quill styles
// Remove if react-draft-wysiwyg is not used
import 'react-draft-wysiwyg/dist/react-draft-wysiwyg.css';
// Remove if simplebar is not used
import 'simplebar-react/dist/simplebar.min.css';
// Remove if mapbox is not used
import 'mapbox-gl/dist/mapbox-gl.css';
// import './global.css';

import App from './App';
import reportWebVitals from './reportWebVitals';

const root = ReactDOM.createRoot(document.getElementById('root'));
// Will render twice times on every re-render:
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);

// Will render 1 time:
// root.render(<App />);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
